import React from "react";
import "./InstructionModel.css";

const InstructionsModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div
      className="instructions-overlay"
      onClick={(e) => {
        if (e.target.classList.contains("instructions-overlay")) onClose();
      }}
    >
      <div className="instructions-card" role="dialog" aria-modal="true">
        <button
          className="instructions-close-btn"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>

        <div className="instructions-content">
          {/* Kannada Instructions */}
          <div className="instructions-section">
            <h2 className="instructions-heading">ಮುಖ್ಯ ಸೂಚನೆಗಳು</h2>
            <ul className="instructions-list">
              <li>ಹೊಸ ನೋಂದಣಿ ಶೀಘ್ರದಲ್ಲೇ ಪ್ರಾರಂಭವಾಗಲಿದೆ.</li>
              <li>
                ಇದುವರೆಗೆ ಶಾಖೆಗಳ ಮೂಲಕ (ಆಫ್‍ಲೈನ್) ನೋಂದಣಿ ಮಾಡಿದ ಬಳಕೆದಾರರು ತಮ್ಮ ನೋಂದಾಯಿತ
                ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಬಳಸಿ ಈಗಲೇ ಲಾಗಿನ್ ಮಾಡಬಹುದು.
              </li>
            </ul>

            <h2 className="instructions-heading">ಲಾಗಿನ್ ಸೂಚನೆಗಳು</h2>
            <ul className="instructions-list">
              <li>ನಿಮ್ಮ ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಬಳಸಿ ಲಾಗಿನ್ ಮಾಡಿ.</li>
              <li>ಮೊದಲಿಗೆ ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯಾಗಿರುತ್ತದೆ.</li>
              <li>ಭದ್ರತಗಾಗಿ, ದಯವಿಟ್ಟು ಮೊದಲ ಲಾಗಿನ್ ನಂತರ ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಮರುಹೊಂದಿಸಿ.</li>
            </ul>

            <h2 className="instructions-heading">ಸಹಾಯ ಬೇಕೆ?</h2>
            <ul className="instructions-list">
              <li>ನಿಮ್ಮ ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ತಿಳಿಯದಿದ್ದರೆ, ದಯವಿಟ್ಟು ನಿಮ್ಮ ಶಾಖೆಯನ್ನು ಸಂಪರ್ಕಿಸಿ.</li>
            </ul>
            
          </div>

          {/* English Instructions */}
          <div className="instructions-section">
            <h2 className="instructions-heading">Important Notes</h2>
            <ul className="instructions-list">
              <li>New registrations will open soon.</li>
              <li>
                Users who have already registered offline at the branches can log in now using
                the instructions below.
              </li>
            </ul>

            <h2 className="instructions-heading">Login Instructions</h2>
            <ul className="instructions-list">
              <li>Log in using your registered mobile number.</li>
              <li>Your initial password is the same as your mobile number.</li>
              <li>For your security, please reset your password after your first login.</li>
            </ul>

            <h2 className="instructions-heading">Need Help?</h2>
            <ul className="instructions-list">
              <li>If you are unsure about your registered mobile number, please contact your branch administrator for assistance.</li>
            </ul>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructionsModal;
